module.exports = __webpack_public_path__ + "media/img/old_carQ_ubezpieczenia-72ad0363.png";